/**
 * Composable pour gérer l'auto-hide de la scrollbar
 * La scrollbar apparaît au survol de la page et pendant le scroll
 */

import { onMounted, onUnmounted } from "vue";

export function useAutoHideScrollbar() {
  let scrollTimeout = null;
  let isScrolling = false;

  const showScrollbar = () => {
    document.documentElement.classList.add("show-scrollbar");
    isScrolling = true;
  };

  const hideScrollbar = () => {
    document.documentElement.classList.remove("show-scrollbar");
    isScrolling = false;
  };

  const handleScroll = () => {
    showScrollbar();

    // Masquer la scrollbar 1 seconde après la fin du scroll
    if (scrollTimeout) {
      clearTimeout(scrollTimeout);
    }

    scrollTimeout = setTimeout(() => {
      hideScrollbar();
    }, 1000);
  };

  const handleMouseMove = () => {
    if (!isScrolling) {
      showScrollbar();

      // Masquer la scrollbar 2 secondes après l'arrêt du mouvement
      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }

      scrollTimeout = setTimeout(() => {
        hideScrollbar();
      }, 2000);
    }
  };

  onMounted(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });
    document.addEventListener("mousemove", handleMouseMove, { passive: true });
  });

  onUnmounted(() => {
    window.removeEventListener("scroll", handleScroll);
    document.removeEventListener("mousemove", handleMouseMove);
    if (scrollTimeout) {
      clearTimeout(scrollTimeout);
    }
  });

  return {
    showScrollbar,
    hideScrollbar,
  };
}
